var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4717 28C22.2037 28 28.4717 21.732 28.4717 14C28.4717 6.26801 22.2037 0 14.4717 0C6.73969 0 0.47168 6.26801 0.47168 14C0.47168 21.732 6.73969 28 14.4717 28Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32686 8.85518C8.85329 9.32874 8.85329 10.0965 9.32686 10.5701L12.7567 14L9.32686 17.4299C8.85329 17.9035 8.85329 18.6713 9.32686 19.1448C9.80042 19.6184 10.5682 19.6184 11.0418 19.1448L14.4717 15.7149L17.9016 19.1448C18.3751 19.6184 19.1429 19.6184 19.6165 19.1448C20.0901 18.6713 20.0901 17.9035 19.6165 17.4299L16.1866 14L19.6165 10.5701C20.0901 10.0965 20.0901 9.32874 19.6165 8.85518C19.1429 8.38161 18.3751 8.38161 17.9016 8.85518L14.4717 12.2851L11.0418 8.85518C10.5682 8.38161 9.80042 8.38161 9.32686 8.85518Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f7d2632f.svg";
export { ForwardRef as ReactComponent };